// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
import { WebServices } from '../../shared/services/webServices';
import { Helpers } from '../../shared/services/helpers';
import { casNgbDateParserFormatter } from '../../shared/services/cas-NgbDateParserFormatter';
import { FormAction } from '../../shared/classes/formAction';
import { FeatureFlagService } from '../../shared/services/featureFlagService';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';

//Config/Globals
import { Enums } from '../../shared/enums.js';

//Auth & Config
import { authToken } from '../../shared/authToken';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
@Component({
    template : '<div class="nedit-main-div" data-test-id="content_narrative_edit">\n\n    <!--Title-->\n    <h2 tabindex="-1" class="cpd-title-div">{{_title}}</h2>\n\n    <div style="margin:0 10px 15px 20px; font-style:italic">Edit an existing narrative - Check "Publish After Points are Assigned" so the CAPP data steward can assign points and publish the new narrative immediately or select "Publish on Next Yearly Rollover" to publish the narrative during the next yearly rollover.</div>\n    <div style="height:10px;"></div>\n\n    <!--Content Loading -->\n    <ng-template #loading>\n        <div class="nedit-ui-content-loading">\n            <img src="public/cpd-images/loading.gif" />\n            <div style="margin-left:10px;">Loading...</div>\n        </div>\n    </ng-template>\n\n    <!--Page Content-->\n    <div *ngIf="!_isLoading(); else loading" class="nedit-ui-row" style="flex-grow:1;">\n\n        <!--Selected Practice Display-->\n        <div class="nedit-ui-cell">\n            <div class="nedit-ui-group-lbl" role="heading" aria-label="Asset"><h3>Asset</h3></div>\n            <div>\n                <span style="font-weight:bold;margin-right:5px;">Asset Code:</span><span>{{_parentPractice?.practice_code}}</span>\n                <span style="font-weight:bold;margin:0 5px 0 20px;">Asset Name:</span><span>{{_parentPractice?.practice_name}}</span>\n            </div>\n        </div>\n\n        <!--Spacer-->\n        <div style="height:30px;"></div>\n\n        <!--Publish block-->\n        <div class="nedit-ui-cell" data-test-id="section_narrative_edit_publish">\n            <div id="lblPublishHeader" class="nedit-ui-group-lbl" role="heading" aria-label="Publish"><h3>Publish</h3></div>\n            <div role="radiogroup" aria-labelledby="lblPublishHeader">\n\n                <!--Manual Publish-->\n                <div class="nedit-radio-div">\n                    <input type="radio" name="rdoPublish" id="rdoManual" [value]="1" [(ngModel)]="bm_publishMode" (change)="fieldChanged()">\n                    <label for="rdoManual">&nbsp;Publish after points assigned</label>\n                </div>\n\n                <div style="border-bottom:solid 1px #ccc; margin-bottom:10px;height:10px;"></div>\n\n                <!--Rollover Publish-->\n                <div class="nedit-radio-div">\n                    <input type="radio" name="rdoPublish" id="rdoRollover" [value]="0" [(ngModel)]="bm_publishMode" (change)="fieldChanged()">\n                    <label for="rdoRollover">&nbsp;Publish on next yearly rollover (start date will be set to rollover date)</label>\n                </div>\n            </div>\n\n        </div>\n\n        <!--Spacer-->\n        <div style="height:30px;"></div>\n\n        <!--Narrative Details block-->\n        <div class="nedit-ui-cell" data-test-id="section_narrative_edit_details">\n            <div class="nedit-ui-group-lbl" role="heading" aria-label="Narrative Details"><h3>Narrative Details</h3></div>\n\n            <div class="cpd-ui-field-div">\n                <!-- Narrative Code -->\n                <label id="lblNarrativeCode" for="txtNarrativeCode" style="width:30px;">Code</label>\n                <input id="txtNarrativeCode"\n                       aria-labelledby="lblNarrativeCode"\n                       maxlength="10"\n                       [(ngModel)]="bm_narrativeCode"\n                       (change)="fieldChanged()"\n                       class="cpd-ui-field-readonly"\n                       style="width:100px;" />\n\n            </div>\n\n            <!--Spacer-->\n            <div style="height:15px;"></div>\n\n            <div class="nedit-field-row" style="align-items:flex-start;">\n                <div class="nedit-field-lbl" style="width:30px;">Text</div>\n                <label class="off-screen" id="lblNarrativeText" for="txtNarrativeText">Text, 2000 characters maximum</label>\n                <textarea id="txtNarrativeText"\n                          aria-labelledby="lblNarrativeText"\n                          [(ngModel)]="bm_narrativeText"\n                          (change)="fieldChanged()"\n                          (paste)="onPaste_narrativeText($event)"\n                          rows="20"\n                          maxlength="1999"\n                          style="width:800px;"></textarea>\n            </div>\n            <div style="font-style:italic; margin-left:40px;">2000 Characters Max</div>\n        </div>\n\n        <!--Popups-->\n        <!--====================================================================================================-->\n\n        <!--POPUP INSTANCE CONTAINER-->\n        <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n        where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n        are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n        <div id="narrative_edit_page_popups"></div>\n        \n        <!--====================-->\n        <!-- Confirmation -->\n        <!--====================-->\n        <modal #popCancelChanges\n               containerId="narrative_edit_page_popups"\n               title="Cancel Changes" \n               label="popCancelChanges">\n\n            <!--FVT-ID-->\n            <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_narrative_edit_confirm_cancel"></section>\n\n            <!-- body -->\n            <section>\n                <div class="cpd-ui-row">\n                    <div class="cpd-ui-cell" style="width:100%">\n                        <div class="cpd-ui-field-div">\n                            Are you sure that you want to cancel your changes?\n                        </div>\n                    </div>\n                </div>\n            </section>\n\n            <!-- footer -->\n            <footer>\n                <!--<button type="button" [attr.disabled]="IsNarrativeEndingPopupValid() ? null : \'disabled\'" class="btn btn-primary" (click)="EndNarrative();narrativesEndingPopup.Close();">Save</button>-->\n                <button type="button" class="btn btn-primary" (click)="popCancelChanges.Close()">Stay on Page</button>\n                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="navBackToList();">Discard Changes</button>\n            </footer>\n        </modal>\n    </div>\n</div>\n\n\n\n\n\n',
    styles : ['.nedit-main-div{display:flex;flex-direction:column;position:absolute;top:0px;right:0px;bottom:0px;left:0px}.nedit-ui-row{position:relative;margin:15px 0 0 0}.nedit-ui-cell{position:relative;background-color:#f0f0f0;border-radius:4px;border:solid 1px #b8b8b8;padding:25px 15px 10px 25px;margin:0 10px;max-width:900px}.nedit-ui-group-lbl{position:absolute;top:-8px;left:5px;background-color:#d4e2f2;border-radius:4px;border:solid 1px #b8b8b8;padding:1px 8px;box-shadow:1px 1px 5px rgba(0,0,0,0.3)}.nedit-ui-content-loading{display:flex;font-style:italic;margin:10px 20px}.nedit-title-div{margin:10px 8px 15px 8px;padding-bottom:4px;border-bottom:solid 1px #b8b8b8}.nedit-radio-div{display:flex;align-items:center}.nedit-field-row{display:flex;align-items:center}.nedit-field-lbl{text-align:right;margin-right:10px}'],
    providers: []
})
export class NarrativeEditComponent {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('popCancelChanges') popCancelChanges;

	//Class wide member reference for the growls control
	growlBox = null;

    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    // Boiler Plater
    _allFieldsDisabled = false;
    _componentName = 'narrativeEdit.js';
    _disposalFunctions = [];
    _formName = "narrative_edit";
    _loading = true;
    _sessionStorageObject = null;
    _title = "Narratives - Edit Narrative";

    //BL
    _changesMade = false; //Set to true if the user changes anything
    _parentPractice = null;
    _narrativeId = 0;
    _originalNarrativeCode = null;
    _practiceId = null;

    //Bound as a model
    bm_narrativeCode = "";
    bm_narrativeText = "";
    bm_publishMode = "0";
    //bm_climateSmart = false;

    //An event listener handler method that will have "this" prebound so removeListener will work (which can't handle
    //removing a listener if it was bound in the registration)
    _boundKeypressHandler = null;

    //Feature Flags
    //_climateSmartFeatureFlag = false;

    // INITIALIZATION/LIFECYCLE
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(
        casNavBoxService: CASNavBoxService,
        cpdFormatters: CPDFormatters,
        ngbDateParser: casNgbDateParserFormatter,
        helpers: Helpers,
        route: ActivatedRoute,
        router: Router,
        webServices: WebServices,
        featureFlagService: FeatureFlagService) {

        this.constructor.mapParams(this, arguments);

        //Handle nav menu events
        let disposable = casNavBoxService.OnActionClicked$.subscribe(action => {
            //console.log("[constructor] Firing:", action.field_name);
            this.navBoxActionClicked(action);
        })

        //console.log("---[constructor] disposable:", disposable);
        this._disposalFunctions.push(disposable);
    }

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        //console.log("--- [ngOnDestroy] Dispose subscriptions:", this._disposalFunctions);
        this._disposalFunctions.map(x => x.unsubscribe());
    }

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {
        this.set508();
        this.initalizeGrowlBox();
        this.performAsyncOperations();
        this.setNavBoxActions();
    };

    //==================================
    // initalizeGrowlBox
    //==================================
    initalizeGrowlBox() {
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({
            appendToElementId: "cpdesGrowlContainer" //cpdesGrowlContainer definied in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        });
    };

    //==================================
    // ngOnInit_Complete
    //==================================
    ngOnInit_Complete() {
        this._markPageAsLoading(false);
    }


    // BL FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // set508
    //==================================
    set508() {
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";

            let el = document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);
    }

    //==================================
    // performAsyncOperations
    //==================================
    performAsyncOperations() {
        //Number of async ops this function has left to complete
        var ops = 2;

        //PRACTICE
        this.loadPractice(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //NARRATIVES
        this.loadNarrative(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //FEATUREFLAGS
        //this._loadFeatureFlags(() => {
        //    if (--ops == 0) { this.ngOnInit_Complete(); }
        //});
    }

    //==================================
    // loadPractice
    //==================================
    loadPractice(onSuccess) {
        this._practiceId = this.route.snapshot.params.practiceId;

        this.webServices.Get({
            apiPath: "/practices/getPractice",
            args: { practiceId: this._practiceId }
        })
            .then(res => {

                console.log(`[${this._componentName}:_loadData():/practices/getPractice] - res: `, res);

                if (res.data.Success) {
                    this._parentPractice = res.data.DTO;

                    if (onSuccess) {
                        onSuccess();
                    }
                }
                else {
                    this.growlBox.addGrowl("error", "There was an error loading the asset");
                    console.log(this.cpdFormatters.formatError(res.data));
                }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", "There was an error loading the asset");
                console.log(this.cpdFormatters.formatError(err));
            });
    }

    //==================================
    // loadNarrative
    //==================================
    //Loads the indicated narrative and it's revision narrative if available
    loadNarrative(onSuccess) {
        this._narrativeId = this.route.snapshot.params.narrativeId;

        //Load the current narrative and if there is one, the revision narrative
        this.webServices.Get({
            apiPath: "/narrative/getNarrativeById",
            args: { narrativeId: this._narrativeId }
        })
            .then(res => {

                console.log(`[${this._componentName}:_loadData():/narrative/getNarrativeById] - res:`, res);

                if (res && res.data && res.data.Success && res.data.DTO) {
                    this.setNarrativeProperties(res.data.DTO);

                    if (onSuccess) {
                        onSuccess();
                    }
                }
                else {
                    this.growlBox.addGrowl("error", "There was an error loading the narrative");
                    console.log(this.cpdFormatters.formatError(res.data));
                }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", "There was an error loading the narrative");
                console.log(this.cpdFormatters.formatError(err));
            });
    }

    //==================================
    // setNarrativeProperties
    //==================================
    setNarrativeProperties(narrative) {
        this.bm_narrativeCode = narrative.practice_narrative_code;
        this.bm_narrativeText = narrative.practice_narrative;
        this.bm_publishMode = narrative.publish_mode;
        this._originalNarrativeCode = narrative.practice_narrative_code;
    }

    //==================================
    // _loadFeatureFlags
    //==================================
    _loadFeatureFlags(fnOnComplete) {

        this.featureFlagService.getFeatureFlags()
            .then(res => {
                //this._climateSmartFeatureFlag = res;
                //console.log("this._climateSmartFeatureFlag:", this._climateSmartFeatureFlag);

                if (fnOnComplete) { fnOnComplete(); }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", "There was an error loading the feature flag");
                console.log(this.cpdFormatters.formatError(err));
            });
    }

    //==================================
    // setNavBoxActions
    //==================================
    setNavBoxActions() {
        let actions = [];

        actions.push(new FormAction("act_cancel_narrative", "Close"));

        switch (authToken.user.role) {
            case Enums.Roles.NHQNationalPracticeDataSteward.id:
                actions.push(new FormAction("act_save_narrative", "<u>S</u>ave Narrative", true, null, "s"));
                break;

            default:
                break;
        }

        //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;
    }

    //==================================
    // saveNarrative
    //==================================
    saveNarrative() {

        console.log("saveNarrative()");

        try {
            this.validateNarrative();
            this.growlBox.addGrowl("info", "Saving updated narrative...");
            this.sendNarrativeToDatabase();
        }
        catch (e) {
            console.log(this.cpdFormatters.formatError(e));
        }
    }

    //==================================
    // validateNarrative
    //==================================
    validateNarrative() {
        if (!this._changesMade) {
            this.growlBox.addGrowl("error", "No changes detected for saving");
            throw "error";
        }

        if (this.bm_narrativeCode.trim().length < 1) {
            this.growlBox.addGrowl("error", "No narrative code detected for saving");
            throw "error";
        }

        if (this.bm_narrativeText.trim().length < 1) {
            this.growlBox.addGrowl("error", "No narrative text detected for saving");
            throw "error";
        }

    }

    //==================================
    // sendNarrativeToDatabase
    //==================================
    sendNarrativeToDatabase() {
        this.webServices.Post("/narrative/dv1_updateNarrative",
            {
                practice_id: this._practiceId,
                practice_narrative_id: this._narrativeId,
                practice_narrative: this.bm_narrativeText,
                practice_narrative_code: this.bm_narrativeCode,
                original_narrative_code: this._originalNarrativeCode,
                publish_mode: this.bm_publishMode
            })
            .then(res => {
                console.log(`[${this._componentName}:saveNarrative()] - res: `, res);

                if (res.Success) {
                    this.growlBox.addGrowl("success", "Save complete");

                    //Clear the screen so the user doesn't think they can modify the Narrative they just added
                    this._changesMade = false;
                }
                else {
                    switch (res.ErrorCode) {

                        case "ERR-NBL-UN1":
                            this.growlBox.addGrowl("error", "Narrative Code already exists.");
                            break;

                        default:
                            this.growlBox.addGrowl("error", res.ErrorMessage);
                    }
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", "There was an error saving the narrative");
                console.log(this.cpdFormatters.formatError(err));
                this.markGridAsLoading(false);
            })
    }

    // UI HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // fieldChanged()
    //==================================
    fieldChanged(e) {
        this._changesMade = true;
    }

    //==================================
    // navBackToList
    //==================================
    navBackToList() {
        this.router.navigate(["/cpdes/practices/narrativesList/" + this._parentPractice.practice_id]);
    }

    //==================================
    // navBoxActionClicked
    //==================================
    navBoxActionClicked(action) {

        console.log("[navBoxActionClicked], action: ", action.field_name);

        //Make sure all "field change" events are triggered
        this.helpers.waffleFocus();

        switch (action.field_name) {

            case "act_cancel_narrative":
                if (this._changesMade) {
                    this.popCancelChanges.Open(); //Calls navBackToList() if user agrees to discard changes
                }
                else {
                    this.navBackToList();
                }
                break;

            case "act_save_narrative":
                this.saveNarrative();
                break;

            case "act_delete_narrative":
                this.deleteNarrative();
                break;
        }
    }

    //==================================
    // onPaste_narrativeText
    //==================================
    onPaste_narrativeText(e) {
        let content = e.clipboardData.getData('text/plain');
        let length = content.length;
        if (length > 1999) {
            alert("Pasted text exceeds 2000 characters.  Excess will be truncated.");
        }
    };

    // BOILER PLATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _disableUI
    //==================================
    _disableUI() {
        this.casNavBoxService.DisableAllLinks();
        this._allFieldsDisabled = true;
    };

    //==================================
    // _enableUI
    //==================================
    _enableUI() {
        this.casNavBoxService.EnableAllLinks();
        this._allFieldsDisabled = false;
    };

    //==================================
    // _isLoading
    //==================================
    _isLoading() {
        return this._loading || this.casNavBoxService.ActionsLoading;
    }

    //==================================
    // _markPageAsLoading
    //==================================
    _markPageAsLoading(isLoading) {
        this._loading = isLoading;
    }

    // DEBUGGING
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _debugEntryClicked
    //==================================
    _debugEntryClicked(entry) {
        console.log("[narratives:_debugEntryClicked]");
        console.log("    ", entry);

        switch (entry) {
            case "Tes 1":
                console.log("Test 1");
            //this._executeOnCondition(
            //    () => { return false; },
            //    () => { console.log("TESTING:DONE"); },
            //    100, 7
            //);
        }
    };

}
